/**
 * @changelog
 *
 * 2026-10-06 (0.1.0) (jhoward)
 *   - Add src\helpers\getReadablePrizeDate.ts, holding the prize date formatting that was inline in
 *     src\components\offers\DisplayPrizes.vue so the redeemed offer status shows the date exactly as the prize
 *     picker did.
 */

import { getDateFromEngage } from '@/helpers/getdateFromEngage';

export default function getReadablePrizeDate(dateTime: string): string {
  const date = getDateFromEngage(dateTime);
  if (date) {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(date);
  }

  return dateTime;
}
